import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default ({ inFilterMenu } = {}) => {
  const { borderRadius, colors } = useTheme();
  const statusColor = inFilterMenu ? 'colors.navy' : colors.white;
  return {
    locationLink: css`
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      gap: 0px;
      align-self: stretch;
      color: ${colors.navy};
      flex-direction: column;
    `,
    locationBtn: css`
      padding: 0px 4px;
      color: ${colors.buttonBlue};
      align-items: center;
      display: inline-flex;
      gap: 10px;

      /* FDS Mobile/Body/Body medium */
      font-family: 'FS Dillon';
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 125% */
      letter-spacing: 0.32px;
      text-decoration-line: underline;
      text-decoration-style: solid;
      text-decoration-skip-ink: none;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
      svg {
        fill: ${colors.buttonBlue};
        display: block;
      }
      &:hover {
        color: ${colors.navy};
        svg {
          fill: ${colors.navy};
        }
      }
      &:focus-visible {
        color: ${colors.border_black};
        background-color: ${colors.skip_yellow};
        outline: none;
        text-decoration-color: ${colors.border_black};
        svg {
          fill: ${colors.border_black};
        }
      }
    `,
    errorMessage: css`
      margin-top: -0.5rem;
      margin-bottom: 0.5rem;
      display: flex;
      padding: 0.25rem 0.5rem;
      gap: 0.625rem;
      border-radius: ${borderRadius.xs} ${borderRadius.xs} ${borderRadius.m}
        ${borderRadius.m};
      background: ${colors.buttonRed};
      color: ${colors.white};
      line-height: 1.25rem;
      letter-spacing: 0.015rem;
      align-items: flex-start;
      width: 100%;
      svg {
        margin-top:3px;
        flex-shrink: 0; 
        min-width: 0.75rem;
      }
    `,
    statusMessage:(locationHasError) => css`
      color: ${statusColor};
      margin-top:${!locationHasError ? '0.5rem' : '0rem'};
      margin-bottom:${!locationHasError ? '-0.5rem' : '0rem'};
    `,
  };
};
